export interface ProgressBarProps {
  max: number;
  value: number;
}

export function ProgressBar({ value, max }: ProgressBarProps) {
  const progressValue = Math.round(-100 * (1 - value / max));

  return (
    <div className="theme--story--progress">
      <progress max={max} value={value} />
      <div className="theme--story--progress--bar" aria-hidden="true">
        <div
          className="theme--story--progress--value"
          style={{
            transform: `translate3d(${progressValue}%, 0, 0)`,
          }}
        />
      </div>
    </div>
  );
}
